
define('text!common/views/discussion/comment-count--content.html',[],function () { return '<a href="<%=url%>" data-link-name="Comment count" class="commentcount2 tone-colour">\n    <h3 class="commentcount2__heading"><%=icon%> Comments</h3>\n    <span class="commentcount2__value tone-colour"><%=count%></span>\n</a>\n';});

